import { atom } from 'recoil';

export interface EmailDomainContent {
    id: string | number;
    domain: string;
}

const emailDomainsState = atom({
    key: 'emailDomainsData',
    default: [] as EmailDomainContent[],
});

export { emailDomainsState };
